<template>
  <v-container>
    <v-layout>
      <v-row 
        class="d-flex align-center justify-center" 
        style="height: 75vh;"
      >
        <v-col class="d-flex justify-end align-center">
          <img src="@/assets/logo.png" height="64px">
          <v-divider
            class="mx-4"
            :inset="true"
            vertical
          ></v-divider>
        </v-col>
        <v-col class="d-flex justify-start">
          <LoginButton
            icon="mdi-google"
            text="Login with Google"
          />
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
  import LoginButton from '@/components/auth/LoginButton'
  
  export default {
    name: 'Login',
    components: {
      LoginButton
    }
  }
</script>
